import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Terms from "../views/Terms.vue";
import Privacy from "../views/Privacy.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "/auth",
    name: "Auth",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/j",
    name: "JinroHome",
    component: () => import("../views/JinroHome.vue"),
  },
  {
    path: "/j/:jinroRoomId",
    component: () => import("../views/JinroRoom.vue"),
  },
  {
    path: "/j/:jinroRoomId/public",
    component: () => import("../views/JinroRoomPublicViewing.vue"),
  },
  {
    path: "/h/:jinroGameId",
    component: () => import("../views/JinroGameHistory.vue"),
  },
  {
    path: "/p/:jinroPlayerId",
    component: () => import("../views/JinroPlayer.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
